import { SEC_ApiCall } from '../func';

/** Load active contacts and their linked pupils for the current school. */
export async function getSysManagerContacts() {
  const response = await SEC_ApiCall('sysmanager/contacts');
  if (!response || typeof response !== 'object' || !Array.isArray(response.items)) {
    throw new Error(response?.message || 'Unexpected contacts response');
  }
  return response;
}
